import { Avatar, Body, Heading } from '@assembly-js/design-system';
import { MenuItem, MenuList, Popover } from '@mui/material';
import React from 'react';

import { NotificationBadge } from 'src/components/NotificationBadge';
import { useCompanySwitcher } from 'src/features/companies/CompanySwitcher';
import { useCompanySwitcherVisibility } from 'src/features/companies/useCompanySwitcherVisibility';
import { useNotificationBadgeData } from 'src/hooks/useNotificationBadgeData';

import { SidebarSwitcherButton } from './SidebarSwitcherButton';

export const CompanySwitcher = () => {
  const {
    companies,
    handleClick,
    handleLogout,
    selectedCompany,
    signoutRedirectURL,
    getCompanyUnreadNotificationsCount,
  } = useCompanySwitcher();
  const { backgroundColor, textColor } = useNotificationBadgeData(true);
  const companySwitcherVisibility = useCompanySwitcherVisibility();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  if (companySwitcherVisibility.visibility !== 'mobile') {
    return null;
  }

  return (
    <div>
      <SidebarSwitcherButton
        ref={anchorRef}
        iconSrc={selectedCompany?.fields.avatarImageURL || ''}
        iconFallbackColor={selectedCompany?.fields.fallbackColor}
        name={selectedCompany?.fields.name || ''}
        isOpen={open}
        onClick={() => setOpen(true)}
      />
      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        classes={{
          paper: 'w-[240px] mt-[2px] ml-[-8px] shadow-dropdown-menu',
        }}
      >
        <MenuList className="p-0">
          {companies.map((company) => (
            <MenuItem
              key={company.id}
              onClick={handleClick(company)}
              className="h-8 p-3 flex items-center justify-between"
            >
              <div className="flex items-center gap-2">
                <Avatar
                  src={company.fields.avatarImageURL || ''}
                  size="sm"
                  fallbackColor={company.fields.fallbackColor}
                  alt={company.fields.name}
                  variant="rounded"
                  text={company.fields.name.slice(0, 1)}
                />
                <Heading className="text-[14px]">{company.fields.name}</Heading>
              </div>
              {getCompanyUnreadNotificationsCount(company.id) > 0 ? (
                <NotificationBadge
                  showZero={false}
                  isSidebar
                  content={getCompanyUnreadNotificationsCount(company.id)}
                  backgroundColor={backgroundColor}
                  textColor={textColor}
                />
              ) : null}
            </MenuItem>
          ))}
          <div className="h-px bg-secondary-hover" />
          <MenuItem
            className="h-8 p-3"
            onClick={() => {
              void handleLogout(false, signoutRedirectURL, true);
            }}
          >
            <Body className="text-[14px]">Log out</Body>
          </MenuItem>
        </MenuList>
      </Popover>
    </div>
  );
};
